import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import useStore from '../store/useStore';
import { setAnalyticsUser } from '../utils/analytics';

/**
 * UserProvider - Initializes global user state from Clerk
 * Called once at app level, populates Zustand store
 */
export const UserProvider = ({ children }) => {
  const { user, isSignedIn, isLoaded } = useUser();
  const { setUser, clearUser, setUserLoading } = useStore();

  useEffect(() => {
    if (!isLoaded) {
      setUserLoading(true);
      return;
    }

    if (isSignedIn && user) {
      // Opaque Clerk id only — never the email/name/phone read just below.
      // Sending those to GA4 violates Google's terms and leaks PII.
      setAnalyticsUser(user.id);

      // Store user data in global state
      setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
        fullName: user.fullName,
        imageUrl: user.imageUrl,
        phone: user.unsafeMetadata?.phone,
      });
    } else {
      // User is signed out, clear store
      setAnalyticsUser(null);
      clearUser();
      if (isLoaded) {
        
      }
    }
  }, [user, isSignedIn, isLoaded, setUser, clearUser, setUserLoading]);

  return children;
};
